import { HttpClient } from "services/httpClient/HttpClient";
import { CarrierIntegrationDto, CarrierIntegrationGetDto, CarrierIntegrationListDto, CreateIntegrationMappingDto,  } from "./types/carrierIntegration/CarrierIntegrationDto";
import { ApiVersion } from "services/httpClient/ApiVersion";
import { ApiError } from "components/common/types/ApiError";

export const CarrierIntegrationApi = {
    list: (searchValue: string = ''): Promise<CarrierIntegrationListDto[]> => {
      return HttpClient.get<CarrierIntegrationListDto[]>(`accountmapping/?search=${searchValue}`, true, true, '', ApiVersion.V2);
    },
    getCarrierIntegrationList:(): Promise<CarrierIntegrationDto[]> => {
      return HttpClient.get<CarrierIntegrationDto[]>('accountmapping/carrierintegrations', true, true, '', ApiVersion.V2);
    },
    create: (payload: CreateIntegrationMappingDto ): Promise<ApiError> => {
      return HttpClient.post<ApiError>('accountmapping/integrationmapping', payload, true, true, '', ApiVersion.V2);
    },
    update: (payload: CreateIntegrationMappingDto, id: string) : Promise <ApiError> => {
      return HttpClient.put<ApiError>(`accountmapping/${id}`, payload, true, true, '', ApiVersion.V2);
    },
    getCarrierIntegration:(id: string): Promise <CarrierIntegrationGetDto[]>=> {
      return HttpClient.get<CarrierIntegrationGetDto[]>(`accountmapping/${id}`, true, true, '', ApiVersion.V2);
    }
}